import type { ReactNode } from "react";
import { useFetchLegalPage, useUpdateTermsAndConditionsStatus } from "@akina/infra";
import { LegalUpdateModal } from "./LegalUpdateModal";

type UpdatedTermsAndPrivacyPolicyAcceptanceModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  app: "care" | "portal";
  entity: "patient" | "therapist";
  messages: { title: string; description: ReactNode; buttonLabel: string; subtext?: ReactNode };
};

export function UpdatedTermsAndPrivacyPolicyAcceptanceModal({
  open,
  onOpenChange,
  app,
  entity,
  messages,
}: Readonly<UpdatedTermsAndPrivacyPolicyAcceptanceModalProps>) {
  const { data: termsLegalPage } = useFetchLegalPage("terms-and-conditions", app);
  const { data: privacyLegalPage } = useFetchLegalPage("privacy-policy-and-data-transparency", app);
  const { mutate, isPending } = useUpdateTermsAndConditionsStatus({ onSuccess: () => onOpenChange(false) }, entity);

  function handleAccept() {
    if (!termsLegalPage?.version || !privacyLegalPage?.version) return;
    const acceptanceTimestamp = new Date().toISOString();
    mutate({
      termsAndConditionsAccepted: true,
      dataPrivacyPolicyAccepted: true,
      termsAndConditionsAcceptedTimestamp: acceptanceTimestamp,
      dataPrivacyPolicyAcceptedTimestamp: acceptanceTimestamp,
      privacyPolicyVersion: privacyLegalPage.version,
      termsVersion: termsLegalPage.version,
    });
  }

  return (
    <LegalUpdateModal
      open={open}
      title={messages.title}
      description={messages.description}
      buttonLabel={messages.buttonLabel}
      subtext={messages.subtext}
      isPending={isPending}
      onAccept={handleAccept}
    />
  );
}
